var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 39,
    viewBox: "0 0 34 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4062 21.615C32.5645 24.9725 28.5874 27.345 20.6326 32.0902C12.9429 36.6772 9.09812 38.9709 5.99963 38.0489C4.71861 37.6677 3.55144 36.9439 2.61013 35.9467C0.333374 33.5347 0.333374 28.8565 0.333374 19.5C0.333374 10.1435 0.333374 5.46524 2.61013 3.0533C3.55144 2.05612 4.71861 1.3322 5.99963 0.95105C9.09812 0.0291269 12.9429 2.32267 20.6326 6.90981C28.5874 11.6549 32.5645 14.0275 33.4062 17.385C33.7536 18.771 33.7536 20.229 33.4062 21.615Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayLogin);
export default __webpack_public_path__ + "static/media/play-login.8840d26050142bdc403e53068c911524.svg";
export { ForwardRef as ReactComponent };